/* m.adam — thème Shopify (JS vanilla) */
(() => {
  'use strict';

  /* Header : état au scroll */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

const logo = document.querySelector('.header-logo');
const nav = document.querySelector('.header-nav');
const burger = document.querySelector('.burger');


function toggleMobileMenu(event) {
  if (window.innerWidth > 749) return;

  event.preventDefault();

  const open = nav.classList.toggle('is-open');

  if (burger) {
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
}

if (nav) {
  if (burger) {
    burger.addEventListener('click', toggleMobileMenu);
  }

  if (logo) {
    logo.addEventListener('click', toggleMobileMenu);
  }
}

  /* Reveal au scroll */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('[data-reveal]').forEach((el) => io.observe(el));

  /* Filtres et tri collection : soumission auto du formulaire natif */
  const collectionFilters = document.getElementById('collection-filters');
  if (collectionFilters) {
    collectionFilters.addEventListener('change', () => collectionFilters.submit());
  }

  /* Sélecteur de taille → variante Shopify */
  document.querySelectorAll('.size-pills').forEach((group) => {
    const form = group.closest('form');
    group.addEventListener('click', (ev) => {
      const btn = ev.target.closest('.size-pill');
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      group.querySelectorAll('.size-pill').forEach((b) => b.setAttribute('aria-pressed', 'false'));
      btn.setAttribute('aria-pressed', 'true');
      if (form) {
        const input = form.querySelector('input[name="id"]');
        if (input && btn.dataset.variantId) input.value = btn.dataset.variantId;
      }
      const priceEl = document.querySelector('[data-current-price]');
      if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
    });
  });
})();
